import request from '@/api/request'

export function listUserBindDevice (data) {
  return request({
    url: 'webapi/gps/userBindDevice/list',
    method: 'post',
    data: data
  })
}

export function getUserBindDevice (bindId) {
  return request({
    url: 'webapi/gps/userBindDevice/getBind/' + bindId,
    method: 'get'
  })
}

export function createUserBindDevice (data) {
  const creatData = {
    userId: data.userId,
    deviceId: data.deviceId,
    mainControl: data.mainControl
  }
  return request({
    url: 'webapi/gps/userBindDevice/create',
    method: 'post',
    data: creatData
  })
}

export function deleteUserBindDevice (data) {
  const delData = {
    bindId: data.bindId
  }
  return request({
    url: 'webapi/gps/userBindDevice/delete',
    method: 'post',
    data: delData
  })
}
